// Contract: Route-preview CTA request events for fallback public route shells. Does not prevent native link navigation.
(() => {
  if (window.HeritageRoutePreviewEvents) return;

  const destinationStatusApi = window.HeritageDestinationStatus;
  if (!destinationStatusApi || typeof destinationStatusApi.getOptionalDatasetValue !== 'function' || typeof destinationStatusApi.getOptionalValue !== 'function' || typeof destinationStatusApi.getSafeRequestState !== 'function' || typeof destinationStatusApi.getNativeDestination !== 'function') return;
  // Keep the layout-owned safe policy stable if an integration later mutates its public facade.
  const getNativeDestination = destinationStatusApi.getNativeDestination;
  const getHandoffDatasetValue = destinationStatusApi.getOptionalDatasetValue;
  const getHandoffValue = destinationStatusApi.getOptionalValue;
  const getSafeDestinationRequestState = destinationStatusApi.getSafeRequestState;
  const storefrontRequestEventsApi = window.HeritageStorefrontRequestEvents;
  if (!storefrontRequestEventsApi || typeof storefrontRequestEventsApi.dispatchRequestEvent !== 'function') return;
  const dispatchStorefrontRequestEvent = storefrontRequestEventsApi.dispatchRequestEvent;
  const getEventTargetClosest = (target, selector) => {
    try { return target?.matches?.(selector) ? target : target?.closest?.(selector) || null; }
    catch (error) { return null; }
  };
  const getRoutePreviewEventTarget = (event) => { try { return event?.target || null; } catch (error) { return null; } };
  const getNestedTarget = (target, selector) => {
    try { return target?.querySelector?.(selector) || null; }
    catch (error) { return null; }
  };

  const getRoutePreviewRequestDetail = (cta, request = {}) => {
    const nativeDestinationRead = getNativeDestination(cta);
    const destination = getHandoffDatasetValue(cta, 'routePreviewDestination') || nativeDestinationRead.nativeDestination || '';
    const nativeDestination = nativeDestinationRead.nativeDestinationReadable
      ? nativeDestinationRead.nativeDestination || destination
      : '';
    const destinationSource = getHandoffDatasetValue(cta, 'routePreviewDestinationSource');
    const declaredDestinationStatus = getHandoffDatasetValue(cta, 'routePreviewDestinationStatus');
    const {
      destinationStatus,
      destinationStatusMismatch,
      requestAllowed,
      blockedReason,
      resolvedDestinationStatus,
    } = getSafeDestinationRequestState({
      allowedDestinationStatuses: ['internal', 'fragment'],
      declaredDestinationStatus,
      nativeDestination,
      nativeDestinationReadable: nativeDestinationRead.nativeDestinationReadable,
      statusOptions: { allowExternal: false },
    });
    const action = getHandoffDatasetValue(cta, 'routePreviewAction') || 'primary';
    const routeHandle = getHandoffDatasetValue(cta, 'routePreviewRouteHandle');
    const requestPayload = {
      action,
      destination,
      destinationSource,
      declaredDestinationStatus,
      destinationStatus,
      destinationStatusMismatch: String(destinationStatusMismatch),
      nativeDestination,
      resolvedDestinationStatus,
      routeHandle,
    };

    return {
      action,
      destination,
      destinationSource,
      declaredDestinationStatus,
      destinationStatus,
      destinationStatusMismatch: String(destinationStatusMismatch),
      nativeDestination,
      resolvedDestinationStatus,
      requestAllowed: String(requestAllowed),
      requestBlockedReason: blockedReason,
      requestPayload,
      requestSource: getHandoffValue(request, 'source') || 'customer_click',
      requestTarget: getHandoffValue(request, 'target') || nativeDestination,
      routeHandle,
    };
  };

  const requestRoutePreviewDestination = (target, request = {}) => {
    const cta = getEventTargetClosest(target, '[data-route-preview-action]') || getNestedTarget(target, '[data-route-preview-action]');
    if (!cta) return null;

    const detail = getRoutePreviewRequestDetail(cta, request);
    const eventName = detail.requestAllowed === 'true'
      ? 'heritage:route-preview-destination-requested'
      : 'heritage:route-preview-destination-blocked';
    dispatchStorefrontRequestEvent(cta, eventName, detail);
    return detail;
  };

  window.HeritageRoutePreviewEvents = {
    getRequestDetail: getRoutePreviewRequestDetail,
    requestDestination: requestRoutePreviewDestination,
  };

  document.addEventListener('click', (event) => {
    const cta = getEventTargetClosest(getRoutePreviewEventTarget(event), '[data-route-preview-action]');
    if (!cta) return;

    requestRoutePreviewDestination(cta);
  });
})();
